import { addScript } from '@tunein/web-utils';
const DEFAULT_MAGNITE_SCRIPT_URL = 'https://micro.rubiconproject.com/prebid/dynamic/11236.js';
export function loadMagnite(scriptUrlOverride) {
    if (!window.pbjs) {
        window.pbjs = { que: [] };
    }
    const doc = window.document;
    const existingScript = doc.querySelector('script[data-magnite-prebid="true"]');
    if (existingScript) {
        return;
    }
    addScript({
        src: scriptUrlOverride || DEFAULT_MAGNITE_SCRIPT_URL,
        async: true,
        appendTo: 'head',
        attributes: {
            'data-magnite-prebid': 'true',
        },
    }).catch(() => undefined);
}
